import { createIcon } from '../icon'
import BestSellerIcon from '../svg/BestSellerIcon'

export const BestSellerIconDefault = createIcon(BestSellerIcon)
